<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="grid" style="max-width:1400px;margin:0 auto;">
  <div class="col">
    <div class="card">
      <h2 class="mt-3 mb-4">Google Logman Links</h2>

      <p-tabView>
        <p-tabPanel header="ARI">
          <div class="grid mt-3">
            <div class="col-12">
              <p-table [value]="ariLinks" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 200px;">Service</th>
                    <th style="width: 300px;">All Property logman Link</th>
                    <th style="width: 300px;">Property specific logman Link</th>
                    <th style="width: 500px;">API Link</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-link>
                  <tr>
                    <td>
                      <strong>{{link.service}}</strong>
                    </td>
                    <td>
                      @if (link.logmanUrl) {
                        <a [href]="link.logmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                          {{link.logmanUrl}}
                        </a>
                      }
                      @if (!link.logmanUrl) {
                        <span class="text-muted">—</span>
                      }
                    </td>
                    <td>
                      @if (link.propertyLogmanUrl) {
                        <a [href]="link.propertyLogmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                          {{link.propertyLogmanUrl}}
                        </a>
                      }
                      @if (!link.propertyLogmanUrl) {
                        <span class="text-muted">—</span>
                      }
                    </td>
                    <td>
                      <span class="text-primary" style="font-family: monospace; font-size: 0.9em;">{{link.apiUrl}}</span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          <div class="mt-3">
            <p class="text-muted"><strong>Notes:</strong> Availability, Inventory, and LOS Rate endpoints accept optional <code>startDate</code>/<code>endDate</code>. If omitted, defaults are applied by the service.</p>
          </div>
        </p-tabPanel>

        <p-tabPanel header="VR Feed">
          <div class="grid mt-3">
            <div class="col-12">
              <p-table [value]="vrFeedLinks" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 200px;">Service</th>
                    <th style="width: 300px;">All Property logman Link</th>
                    <th style="width: 300px;">Property specific logman Link</th>
                    <th style="width: 500px;">API Link</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-link>
                  <tr>
                    <td>
                      <strong>{{link.service}}</strong>
                    </td>
                    <td>
                      @if (link.logmanUrl) {
                        <a [href]="link.logmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                          {{link.logmanUrl}}
                        </a>
                      }
                      @if (!link.logmanUrl) {
                        <span class="text-muted">—</span>
                      }
                    </td>
                    <td>
                      @if (link.propertyLogmanUrl) {
                        <a [href]="link.propertyLogmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                          {{link.propertyLogmanUrl}}
                        </a>
                      }
                      @if (!link.propertyLogmanUrl) {
                        <span class="text-muted">—</span>
                      }
                    </td>
                    <td>
                      <span class="text-primary" style="font-family: monospace; font-size: 0.9em;">{{link.apiUrl}}</span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

